import { InterviewsActionTypes } from '../types';
import { makeAsyncActionCreators } from '../../helpers';

const getInterviewsInfo = makeAsyncActionCreators(
  InterviewsActionTypes.getInterviewsInfo,
  ['customerId', 'projectId'],
  ['interviews', 'users', 'package', 'book'],
  ['error'],
);

const sendInterviewInvite = makeAsyncActionCreators(
  InterviewsActionTypes.sendInterviewInvite,
  ['interview'],
  ['interview', 'isFirstInterview'],
  ['error'],
);

const updateInterview = makeAsyncActionCreators(
  InterviewsActionTypes.updateInterview,
  ['interview'],
  ['interview'],
  ['error'],
);

const attachFileToInterview = makeAsyncActionCreators(
  InterviewsActionTypes.attachFileToInterview,
  ['projectId', 'interviewId', 'interviewFile'],
  ['interview', 'newFileId'],
  ['error'],
);

const deleteFileFromInterview = makeAsyncActionCreators(
  InterviewsActionTypes.deleteFileFromInterview,
  ['interviewId', 'interviewFileId'],
  ['interview'],
  ['error'],
);

const downloadFileOfInterview = makeAsyncActionCreators(
  InterviewsActionTypes.downloadFileOfInterview,
  ['interviewId', 'interviewFileId'],
  ['interview'],
  ['error'],
);

const toggleAudioFilesRequired = makeAsyncActionCreators(
  InterviewsActionTypes.toggleAudioFilesRequired,
  ['interviewId'],
  ['interview'],
  ['error'],
);

const transcribeFileOfInterview = makeAsyncActionCreators(
  InterviewsActionTypes.transcribeFileOfInterview,
  ['interviewFileId'],
  ['interview'],
  ['error'],
);

export default {
  getInterviewsInfo,
  sendInterviewInvite,
  updateInterview,
  attachFileToInterview,
  deleteFileFromInterview,
  downloadFileOfInterview,
  toggleAudioFilesRequired,
  transcribeFileOfInterview,
};
